import React, {useEffect, useState} from "react";
import Button from "react-bootstrap/Button";
import AcquireCddsContent from "@pages/dvtjcuv/rundvtjcuv/accquirecdd/AcquireCddsContent";
import {DVTJCUVAcquireCddParentTabs, DVTJCUVAcquireCddParentTabIds} from "@pages/dvtjcuv/common/AcquireCddTabs";
import HeaderSearchButtons from "@pages/dvtjcuv/rundvtjcuv/HeaderSearchButtons";
import { DVTJCUVPipelineBlock } from '@pages/dvtjcuv/common/Constant';


const AcquireCddManager = (props) => {
    const [showBtnSearchPipeline, setShowBtnSearchPipeline] = useState(false);
    const [currentParentTab, setCurrentParentTab] = useState(DVTJCUVAcquireCddParentTabs[1]);
    const [runJobInfo, setRunJobInfo] = useState({
        email_tab: {}
    });

    const {runJob} = props

    const hash = window.location.hash.substring(1);

    useEffect(() => {
        if (runJob) {
            setRunJobInfo({...runJob})
        }
    }, [runJob]);

    useEffect(() => {
        DVTJCUVAcquireCddParentTabs.forEach(tab => {
            if (hash && hash === tab.id) {
                setCurrentParentTab(tab);
            }
        })
    }, []);


    const activeTab = (tab) => {
        console.log('currentParentTab:', currentParentTab)
        if (currentParentTab.id === tab.id) {
            return 'active'
        }
        return ''
    }

    const onClickTab = (tab) => {
        // alert('onClickTab:' + tab.id)
        setCurrentParentTab(tab)
        window.location.hash = tab.id
        setShowBtnSearchPipeline(tab.id !== DVTJCUVAcquireCddParentTabIds.EMAIL_TAB
             && tab.id !== DVTJCUVAcquireCddParentTabIds.PRE_EMAIL_TAB)
    }

    return (
        <div className="card card-default">
            <div className="card-header">
                <h3 className="card-title text-bold">ACQUIRE CDDs</h3>
                <button type="button" className="btn btn-tool" data-card-widget="collapse">
                    <i className="fas fa-minus"/>
                </button>
                <div className="card-tools pr-2 col-6">
                    <HeaderSearchButtons
                        parentTabId={DVTJCUVPipelineBlock.AcquireCddManager}
                        showBtnSearchPipeline
                        showBtnSearchCdd
                    />
                </div>
            </div>
            <div className="card-body">
                <ul className='nav nav-tabs' role='tablist'>
                    {DVTJCUVAcquireCddParentTabs.map(tab => (
                        <li className='nav-item' key={tab.id}>
                            <a className={`nav-link ${activeTab(tab)}`} data-toggle='tab' href={`#${tab.id}`}
                               onClick={() => onClickTab(tab)}>{tab.title}</a>
                        </li>
                    ))}
                </ul>
                <div className='tab-content'>
                    {DVTJCUVAcquireCddParentTabs.map((tab, index) => {
                        if (currentParentTab.id === tab.id) {
                            return <div id={tab.id} className={`tab-pane active`}>
                                <AcquireCddsContent data={runJobInfo} parentTab={tab}/>
                            </div>
                        }
                        return ""
                    })}
                </div>
            </div>
        </div>
    )
}

export default AcquireCddManager;
